var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-box"},[_c('div',{staticClass:"bar-info"},[_vm._v(" "+_vm._s(_vm.willMemberShipText)+" "),_c('span',{staticClass:"rule",on:{"click":_vm.openJoinRules}},[_vm._v(_vm._s(_vm.$t('FoodC_subscription_VPMP_seXT')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }